<div *ngIf="dataSource?.Name" class="flex flex-wrap gap-4 my-4 justify-between items-center border border-solid p-3 rounded-xl">
    <div class="flex items-center">
        <img *ngIf="dataSource?.Image; else noImage" [src]="dataSource?.Image" height="48" width="48"
              (error)="onImageError($event)" 
            alt="اقامتگاه با {{dataSource?.Name}}" class="rounded-full w-[48px] h-[48px] mx-2">
        <ng-template #noImage>
            <img [src]="'assets/images/user-accommodation.png'" height="48" width="48" alt="اقامتگاه با {{dataSource?.Name}}"
                class="rounded-full w-[48px] h-[48px] mx-2">
        </ng-template>
        <div>
            <p class="text-base font-bold">
              اقامتگاه با میزبانی {{dataSource?.Name}}
            </p>
            <P class="text-base font-bold" >
                <span class="text-gray-500" *ngIf="dataSource?.Point">امتیاز {{dataSource?.Point}} از 5 </span>
                <span *ngIf="dataSource?.CountSuccessReserves && dataSource?.Point">
                    -
                 </span>
                <span *ngIf="dataSource?.CountSuccessReserves">
                    
                    {{dataSource?.CountSuccessReserves}} رزرو موفق</span>
            </P>
        </div>
    </div>
    <div class="lg:text-left text-right mx-auto lg:mx-0" >
        <p class="text-base font-bold text-gray-500 mx-3" *ngIf="dataSource?.HouseId">
            کد آگهی :{{dataSource?.HouseId}}
        </p>
        <a mat-button color="primary" [href]="dataSource?.AccomodationsLink"
        *ngIf="dataSource?.AccomodationsLink"
            class="icon-arrow-button  flex items-center">
            <span class="text-blue-500 text-sm !font-medium">لینک دیگر واحدهای اقامتی این میزبان</span>
            <i class="ico-Left text-2xl text-blue-500"></i>
        </a>
    </div>
</div>